export var AIChatPageInitialState = {
  error: undefined
};
export var initialAIChatState = {
  // Initial state
  error: undefined,
  // Get conversations
  currentConversationId: null,
  getConversationsWithMessagesStatus: null,
  // Get messages
  messages: [],
  getMessagesStatus: null,
  messagesNextToken: null,
  // Send message
  sendMessageStatus: null,
  sendMessageOutput: null,
  currentMessageId: null,
  // Streaming
  isStreaming: false,
  streamingMessageId: null,
  streamingContent: '',
  streamChatStatus: null,
  // Stop message
  stopMessageStatus: null,
  // Create AI Attachment Files
  createAiAttachmentFilesStatus: null,
  createAiAttachmentFilesOutput: null,
  // Validate Public File URL
  validatePublicFileUrlStatus: null,
  validatePublicFileUrlOutput: null,
  // Upload Conversation Files
  uploadConversationFilesStatus: null,
  uploadConversationFilesOutput: null,
  // Prompt templates
  promptTemplatesStatus: null,
  promptTemplates: [],
  // LLM Providers
  llmProvidersStatus: null,
  llmProviders: [],
  // Billing
  usageWalletStatus: null,
  usageWallet: null,
  accountingSubscriptionStatus: null,
  accountingSubscription: null,
  // UI state
  inputValue: '',
  attachments: []
};